// Module
var code = "<react-component name=\"AttendanceNotesReport\"></react-component>\n";
// Exports
module.exports = code;